import { useStore } from "@store/store";
import { Box } from "@ecco/ui/box";
import { Circle } from "@ecco/ui/circle";
import { Grid } from "@ecco/ui/grid";
import { NextImage } from "@ecco/ui/next-image";
import { isEmpty } from "lodash-es";

export const CardItems = ({ selectedProductData }: any) => {
    const getStoreData = useStore((state) => state.getStoreData);
    const storeData = getStoreData();

    const hasMatchingChannel = (item) => {
        const itemSupplyChannels = item?.variant?.availability?.channels?.results;
        return itemSupplyChannels.some(
            (variant) => variant?.channel?.id === storeData?.supplyChannel?.[0].id
        );
    };

    return (
        <Grid templateColumns={"repeat( 6, minmax(70px, 1fr) )"} gap={2} pt={2}>
            {selectedProductData.map((product, i) => {
                return (
                    <Box key={i} position="relative">
                        <Box backgroundColor={"gray.50"}>
                            <Circle
                                size={2}
                                position="absolute"
                                bg={
                                    !isEmpty(storeData)
                                        ? hasMatchingChannel(product)
                                            ? "green.200"
                                            : "yellow.200"
                                        : ""
                                }
                                top={-2}
                                right={-2}
                            />
                            <NextImage
                                alt={""}
                                aspectRatio={["4/5"]}
                                src={product.variant?.images?.[0]?.url}
                                sizes={["50vw"]}
                            />
                        </Box>
                    </Box>
                );
            })}
        </Grid>
    );
};
